import { Route } from "react-router-dom";
import ManageDefaultRoutes from "../../ManageDefaultRoutes";
import Dashboard from "../../../pages/Financial/CashOutFlow/Dashboard";
import AcademicEx from "../../../pages/Financial/CashOutFlow/AcademicEx";
import ResidentialEx from "../../../pages/Financial/CashOutFlow/ResidentialEx";
import MarketingEx from "../../../pages/Financial/CashOutFlow/MarketingEx";
import Charity from "../../../pages/Financial/CashOutFlow/Charity";
import Salaries from "../../../pages/Financial/CashOutFlow/AcademicEx/Salaries";
import MaterialAndResources from "../../../pages/Financial/CashOutFlow/AcademicEx/MaterialAndResources";
import TransportCost from "../../../pages/Financial/CashOutFlow/AcademicEx/TransportCost";
import LabEquipment from "../../../pages/Financial/CashOutFlow/AcademicEx/LabEquipment";
import LibraryResources from "../../../pages/Financial/CashOutFlow/AcademicEx/LibraryResources";
import TechnologyLearning from "../../../pages/Financial/CashOutFlow/AcademicEx/TechnologyLearning";
import Examination from "../../../pages/Financial/CashOutFlow/AcademicEx/Examination";
import AcademicEvent from "../../../pages/Financial/CashOutFlow/AcademicEx/AcademicEvent";
import ProfessionalDevelopment from "../../../pages/Financial/CashOutFlow/AcademicEx/ProfessionalDevelopment";
import PersonalityDevelopment from "../../../pages/Financial/CashOutFlow/AcademicEx/PersonalityDevelopment";
import MiscellaneousCost from "../../../pages/Financial/CashOutFlow/AcademicEx/MiscellaneousCost";
import AccommodationMaintenance from "../../../pages/Financial/CashOutFlow/ResidentialEx/AccommodationMaintenance";
import CleaningAndSanitation from "../../../pages/Financial/CashOutFlow/ResidentialEx/CleaningAndSanitation";
import ElectricBilling from "../../../pages/Financial/CashOutFlow/ResidentialEx/ElectricBilling";
import FoodAndDining from "../../../pages/Financial/CashOutFlow/ResidentialEx/FoodAndDining";
import OtherMainteneance from "../../../pages/Financial/CashOutFlow/ResidentialEx/OtherMainteneance";

const CashOutFlowRoutes = (
  <>
    <Route path="cashoutflow/*">
      <Route index element={<ManageDefaultRoutes path="dashboard" />} />
      <Route path="dashboard" element={<Dashboard />} />
      {/* <Route path="academicex" element={<AcademicEx />} /> */}
      <Route path="academicex">
        <Route index element={<AcademicEx />} />
        <Route path="salaries" element={<Salaries />} />
        <Route path="material-resources" element={<MaterialAndResources />} />
        <Route path="transport-cost" element={<TransportCost />} />
        <Route path="lab-equipment" element={<LabEquipment />} />
        <Route path="library-resources" element={<LibraryResources />} />
        <Route path="technology-learning" element={<TechnologyLearning />} />
        <Route path="examination" element={<Examination />} />
        <Route path="academic-events" element={<AcademicEvent />} />
        <Route
          path="professional-development"
          element={<ProfessionalDevelopment />}
        />
        <Route
          path="personality-development"
          element={<PersonalityDevelopment />}
        />
        <Route path="miscellaneous-cost" element={<MiscellaneousCost />} />
      </Route>
      <Route path="residentialex">
        <Route index element={<ResidentialEx />} />
        <Route path="salaries" element={<Salaries />} />
        <Route path="accommodation-maintenance" element={<AccommodationMaintenance />} />
        <Route path="cleaning-and-sanitation" element={<CleaningAndSanitation />} />
        <Route path="electric-billing" element={<ElectricBilling />} />
        <Route path="food-and-dining" element={<FoodAndDining />} />
        <Route path="other-mainteneance" element={<OtherMainteneance />} />
      </Route>
      <Route path="marketingex" element={<MarketingEx />} />
      <Route path="charity" element={<Charity />} />
    </Route>
  </>
);
export default CashOutFlowRoutes;
